<script setup lang="ts">
defineProps<{ size?: number; label?: string }>();
</script>

<template>
  <div class="wrap">
    <span class="spin" :style="{ width: (size ?? 20) + 'px', height: (size ?? 20) + 'px' }" />
    <span v-if="label" class="muted small">{{ label }}</span>
  </div>
</template>

<style scoped>
.wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 24px;
}
.spin {
  border-radius: 50%;
  border: 2px solid var(--border-strong);
  border-top-color: var(--accent);
  animation: st-spin 0.8s linear infinite;
}
</style>
